import { useState, useContext } from "react";
import { useEffect } from "react";
import "./WellComp.css";
import WellCompFaceplate from "../components/WellCompFaceplate";
import { WellContext } from "../context/WellContext";

import { trackPageVisit } from "../competency/PageTracker";
import { useLocation } from "react-router-dom";
import showPreSimulationSteps from "./PreSimulationPopUp";







/* ✅ WELLHEAD BOX */
function WellheadBox({ label, x, y, onClick }) {
  return (
    <div
      className="wellhead-box"
      style={{
        position: "absolute",
        left: x,
        top: y,
        cursor: "pointer"
      }}
      onClick={onClick}
    >
      {label}
    </div>
  );
}

function WellComp() {





  const [acceptPreSimulation, setAcceptPreSimulation] = useState(false);

  const location = useLocation();
  const fromLogin = location.state?.fromLogin || false;

  useEffect(() => {

    trackPageVisit("WellComp");

  }, []);

  useEffect(() => {
    if (fromLogin) {
      showPreSimulationSteps();
    }
  }, [fromLogin]);
  

  const { wellData, updateData } = useContext(WellContext);

  const [openPanels, setOpenPanels] = useState([]);

  const normalizeLabel = (label) => {
    if (label.includes("NK-1")) return "NK1";
    if (label.includes("NK-2")) return "NK2";
    if (label.includes("NK-3")) return "NK3";
    if (label.includes("H2O")) return "H2O_INJECTION"; // ✅ added
    return label;
  };

  const openPanel = (label) => {
    if (!openPanels.includes(label)) {
      setOpenPanels(prev => [...prev, label]);
    }
  };

  const closePanel = (label) => {
    setOpenPanels(prev => prev.filter(p => p !== label));
  };

  const handleUpdateData = (label, newData) => {
    const key = normalizeLabel(label);
    updateData(key, newData);
  };

  return (
    <div className="WellComp">

      <h2 style={{
        position: "absolute",
        top: "-16px",
        left: "280px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "4px 265px"
      }}>
        WELL COMPOSITIONS
      </h2>

      {/* NK WELLS */}
      <WellheadBox
        label="NK-1 WELLHEAD"
        x={240}
        y={90}
        onClick={() => openPanel("NK-1 WELLHEAD")}
      />

      <WellheadBox
        label="NK-2 WELLHEAD"
        x={530}
        y={58}
        onClick={() => openPanel("NK-2 WELLHEAD")}
      />

      <WellheadBox
        label="NK-3 WELLHEAD"
        x={750}
        y={58}
        onClick={() => openPanel("NK-3 WELLHEAD")}
      />

      {/* ✅ H2O INJECTION WELLHEAD */}
      <WellheadBox
        label="H2O INJECTION"
        x={1050}
        y={120}
        onClick={() => openPanel("H2O INJECTION")}
      />

      {/* FACEPLATES */}
      {openPanels.map((panel, index) => (
        <WellCompFaceplate
          key={panel}
          title={panel}
          data={wellData[normalizeLabel(panel)] || {}}
          updateData={handleUpdateData}
          close={() => closePanel(panel)}
          defaultPosition={{
            x: 300 + index * 40,
            y: -20 + index * 40
          }}
        />
      ))}

    </div>
  );
}

export default WellComp;